export default "__VITE_ASSET__wAQ7x231__"